import styled from 'styled-components';

export const StyledFormErrors = styled.div`
  background: #ffe9e6;
  color: ${props => props.theme.colors.primary};
  font-size: ${props => props.theme.fontSizes.small};
  padding: 20px;
  display: block;
  margin-bottom: 15px;
  border-radius: ${props => props.theme.borderRadius};

  ul {
    margin: 15px 0 0;
    padding: 0 0 0 18px;

    li {
      line-height: 1.6;
    }
  }
`
